// extracted by mini-css-extract-plugin
export var externalLink = "_8j-0";
export var internalLinkLabel = "_8j-1";